// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const HoneycombIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="HoneycombIcon" ref={forwardedRef} {...props}>
      <path d="m2.5 9.868 3.386 1.953v3.806L10 18l4.114-2.373v-3.806L17.5 9.868V5.123L13.386 2.75 10 4.703 6.614 2.75 2.5 5.123zM9.22 5.99v2.97l-2.64 1.523-2.574-1.484V5.991l2.608-1.504zm4.2 4.492-2.64-1.523V5.99l2.607-1.504 2.608 1.504V9zM10 10.287l2.608 1.504v2.968L10 16.263l-2.608-1.504V11.79z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const HoneycombIcon = /* @__PURE__ */ Object.assign(
  HoneycombIconComponent,
  { displayName: 'HoneycombIcon' },
);
